import React from 'react';
import FormGroupSelectMultiple from "../../formGroupSelectMultiple";
import Button from "../../button";
import GeneralSVG from "../../generalSVG";
import FormGroupSelectInput from "../../formGroupSelectInput";
import _ from 'lodash';

const Step2 = (props) => {
    if (props.currentStep !== 2)
        return null;
    return (
        <div >
            {
                props.openDamageBandModal ?
                    <div className="solicitorGroupList-modal">
                        <div className="premiumSettingsWizard-modal-content">
                            <div className="appFormRefSettings-close-button"
                                 onClick={() => {
                                     props.changeStoreSettings('openDamageBandModal', false);
                                     props.changeStoreSettings('selectedDamages', []);
                                     props.changeStoreSettings('checkedDamagesIds', []);
                                 }}></div>
                            {/*<FormGroupSelectMultiple*/}
                            {/*Name="selectedDamages"*/}
                            {/*HandleCheckedState={props.handleDamagesCheckedState}*/}
                            {/*HandleInputChange={props.handleDamagesSelectMultipleChange}*/}
                            {/*Label="Damages"*/}
                            {/*Required={true}*/}
                            {/*Options={props.getDamagesNotInDamageBands().map(damage => {*/}
                            {/*return {id: damage.id, range: damage.range}*/}
                            {/*})}*/}
                            {/*LeftWrapper="col-sm-3"*/}
                            {/*CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"*/}
                            {/*RightWrapper=""*/}
                            {/*InputWrapper="col-sm-6 formGroup-textInput-input-wrapper"*/}
                            {/*/>*/}
                            <FormGroupSelectInput
                                Label="Damage Band"
                                LeftWrapper="col-sm-3"
                                Required={true}
                                Name="startOfDamageBand"
                                Value={props.startOfDamageBand}
                                Options={props.getStartDamageBands()}
                                HandleInputChange={(evt) => props.changeStoreSettings(evt.target.name, evt.target.value)}
                                CenterWrapper="col-sm-3 formGroupSelectInput-select-wrapper"
                                RightWrapper="col-sm-4"
                                rightData={
                                    <FormGroupSelectInput
                                        Label="to"
                                        LeftWrapper="col-sm-3"
                                        Required={false}
                                        Name="endOfDamageBand"
                                        Value={props.endOfDamageBand}
                                        Options={props.getEndDamageBands()}
                                        HandleInputChange={(evt) => props.changeStoreSettings(evt.target.name, evt.target.value)}
                                        CenterWrapper="col-sm-9 formGroupSelectInput-select-wrapper"
                                        SelectStyle={'form-control formGroupSelectInput-select'}
                                    />
                                }
                                SelectStyle={'form-control formGroupSelectInput-select'}

                            />
                            <Button
                                clickHandler={() => {
                                    props.setDamageBand()
                                } }
                                wrapper="btn-wrapper-forForms"
                                btnType="button"
                                btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                label="Save Damage Band"
                            />
                            <div onClick={() => {
                                    props.changeStoreSettings('openDamageBandModal', false);
                                    props.changeStoreSettings('selectedDamages', []);
                                    props.changeStoreSettings('checkedDamagesIds', []);}}>
                                <GeneralSVG
                                    SvgWrapper="generalTab-readMore-wrapper inlineBlock "
                                    Label="Cancel"
                                    Svg={<svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 9.6 16"><title>
                                        Asset
                                        2</title>
                                        <g id="Layer_2"
                                           data-name="Layer 2">
                                            <g id="Layer_1-2"
                                               data-name="Layer 1">
                                                <path
                                                    d="M9.6,8.08a1.63,1.63,0,0,1-.48,1.16L2.81,15.53A1.63,1.63,0,0,1,.52,13.21L5.68,8.07.47,2.78A1.63,1.63,0,1,1,2.78.49L9.13,6.94A1.63,1.63,0,0,1,9.6,8.08Z"/>
                                            </g>
                                        </g>
                                    </svg>}
                                />
                            </div>
                        </div>
                    </div>
                    :
                    null
            }
            <p className="premiumSettingsWizard-step-message">{props.stepMessage}</p>
            <Button
                clickHandler={() => {
                    props.changeStoreSettings('openDamageBandModal', true)
                } }
                wrapper="btn-wrapper spacing"
                btnType="button"
                btnStyle={'btn btn-primary btn-xs sharp blue'}
                label="Add New Damage Band"
            />
            <table className="table table-striped">
                <thead className="table-head">
                <tr>
                    <th>Damage Bands</th>
                </tr>
                </thead>
                <tbody className="appFormRefSettings-tbody">
                {
                    props.damageBands.map((band, index) => {
                        return <tr key={index}>
                            <td>{props.getDamageBandName(band)}
                                <div className="displayRight" onClick={() => props.removeDamageBand(index)}>
                                    <GeneralSVG
                                        SvgWrapper="generalTab-readMore-wrapper inlineBlock "
                                        Label="Remove"
                                        Svg={<svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 9.6 16"><title>
                                            Asset
                                            2</title>
                                            <g id="Layer_2"
                                               data-name="Layer 2">
                                                <g id="Layer_1-2"
                                                   data-name="Layer 1">
                                                    <path
                                                        d="M9.6,8.08a1.63,1.63,0,0,1-.48,1.16L2.81,15.53A1.63,1.63,0,0,1,.52,13.21L5.68,8.07.47,2.78A1.63,1.63,0,1,1,2.78.49L9.13,6.94A1.63,1.63,0,0,1,9.6,8.08Z"/>
                                                </g>
                                            </g>
                                        </svg>}
                                    />
                                </div>
                            </td>
                        </tr>
                    })
                }
                </tbody>
            </table>
        </div>
    )
};

export default Step2;